module.exports = __webpack_public_path__ + "img/delete.c6a29a1e.svg";